import { render, staticRenderFns } from "./LostAboutVip.vue?vue&type=template&id=03d4326b&scoped=true&"
import script from "./LostAboutVip.vue?vue&type=script&lang=js&"
export * from "./LostAboutVip.vue?vue&type=script&lang=js&"
import style0 from "./LostAboutVip.vue?vue&type=style&index=0&id=03d4326b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d4326b",
  null
  
)

export default component.exports